import initMK from '../_core/init.js';
import triggerOne from '../trigger/_triggerone.js';
import defineProp from '../_core/defineprop.js';
import domEventReg from './_domeventregexp.js';
import addDomListener from './_adddomlistener.js';
import { addOwner } from './_owners.js';
import { isDuplicateCallback } from '../_helpers/issamecallback.js';
import assign from '../_helpers/assign.js';
// property modifier event regexp
var propModEventReg = /^_change:deps:|^_change:bindings:|^_change:delegated:|^_change:common:|^_change:tree:|^change:|^beforechange:/;
// adds simple event listener
// used as core of event engine
export default function addListener(object, name, callback, context, info) {
  var _info$owner;
  if (info === void 0) {
    info = {};
  }
  var _initMK = initMK(object),
    allEvents = _initMK.events;
  var ctx = context || object;
  var events = allEvents[name];
  // a delegation passes its owner; the internal events of a delegation pass their owners list
  var owner = (_info$owner = info.owner) != null ? _info$owner : null;
  var event = {
    callback: callback,
    context: context,
    ctx: ctx,
    name: name,
    info: assign({
      owners: [owner]
    }, info)
  };
  // skipChecks is used by internal methods for better performance
  var _info = info,
    _info$skipChecks = _info.skipChecks,
    skipChecks = _info$skipChecks === void 0 ? false : _info$skipChecks;
  if (!skipChecks) {
    var domEventExecResult = domEventReg.exec(name);
    if (domEventExecResult) {
      var eventName = domEventExecResult[1],
        _domEventExecResult$ = domEventExecResult[2],
        key = _domEventExecResult$ === void 0 ? 'sandbox' : _domEventExecResult$,
        selector = domEventExecResult[3];
      var isAdded = addDomListener(object, key, eventName, selector, callback, context, info, name);
      if (isAdded) {
        triggerOne(object, "addevent:" + name, event);
        triggerOne(object, 'addevent', event);
      }
      return isAdded;
    }
  }
  // if there are events with the same name
  if (events) {
    if (!skipChecks) {
      // if there are events with the same data, return false
      for (var i = 0; i < events.length; i++) {
        var existingEvent = events[i];
        if (isDuplicateCallback(callback, existingEvent.callback) && existingEvent.context === context) {
          // the listener is kept until everyone who added it removes it
          addOwner(existingEvent, owner);
          return false;
        }
      }
    }
    // if the event isn't found add it to the event list
    events.push(event);
  } else {
    // if there are no events with the same name, create an array with only  one event
    allEvents[name] = [event];
  }
  if (propModEventReg.test(name)) {
    // define needed accessors for KEY
    defineProp(object, name.replace(propModEventReg, ''));
  }
  // names prefixed by underscore mean "private" events
  if (!skipChecks && name[0] !== '_') {
    triggerOne(object, "addevent:" + name, event);
    triggerOne(object, 'addevent', event);
  }
  // if event is added successfully return true
  return true;
}